/** @format */

import AxiosClient from "../AxiosClient";

export const getPayments = params => {
  const url = "/api/payment/searchInfoList";
  return AxiosClient.post(url, params);
};

export const getPaymentById = paymentId => {
  const url = "/api/payment/searchInfoList";
  const params = { paymentId };
  return AxiosClient.post(url, params);
};

export const addPayment = params => {
  const url = "/api/payment/insertInfo";
  return AxiosClient.post(url, params);
};

export const updatePayment = params => {
  const url = "/api/payment/updateInfo";
  return AxiosClient.post(url, params);
};

export const getPaymentMethods = () => {
  return AxiosClient.get(`/api/payment/method`);
};

export const getPaymentConfirmation = (params = {}) => {
  return AxiosClient.get(
    `/api/payment/payment-confirmation?date=${params.date}&closingDateCd=${params.closingDateCd}&keyWord=${params.keyWord}&isPayment=${params.isPayment}&paymentMethod=${params.paymentMethod}&isSale=${params.isSale}&hasBillingAmount=${params.hasBillingAmount}&page=${params.page}&size=${params.size}`
  );
};

export const getListTransferConfirmation = (params = {}) => {
  const url = `/api/payment/transfer-confirmation?date=${params.date}&keyword=${params.keyword}&jaSelection=${params.jaSelection}&jaBranchSelection=${params.jaBranchSelection}&existsPayment=${params.existsPayment}&region=${params.region}&page=${params.page}&size=${params.size}`;
  return AxiosClient.get(url);
};

export const updateWithdrawal = (requestBody = {}) => {
  const url = `/api/payment/update-withdrawal`;
  return AxiosClient.put(url, requestBody);
};
